import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { PrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { filter } from 'rxjs';
import { I18nService } from '../application/common/services/i18n.service';
import { ThemeService } from '../application/common/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslocoPipe, ToastModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  readonly languages = [
    { value: 'es', label: 'Español' },
    { value: 'en', label: 'English' },
  ];
  activeLanguage = 'es';
  showAuthLangSelector = false;

  constructor(
    private readonly primeng: PrimeNG,
    private readonly i18nService: I18nService,
    private readonly router: Router,
    readonly themeService: ThemeService,
  ) {}

  ngOnInit() {
    this.primeng.ripple.set(true);
    this.themeService.initialize();
    this.activeLanguage = this.i18nService.initialize();
    this.updateAuthSelectorVisibility(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.updateAuthSelectorVisibility(event.urlAfterRedirects);
      });
  }

  onLanguageChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.activeLanguage = this.i18nService.setLanguage(selectElement.value);
  }

  private updateAuthSelectorVisibility(url: string): void {
    this.showAuthLangSelector = url.startsWith('/auth');
  }
}
